<template>
    <div>
        <!-- ant-design-vue 组件 -->
        <a-card id="capture-card" title="报表截图" style="width: 800px">
            <div ref="chartContainer">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-statistic title="销售额" :value="112893" />
                    </a-col>
                    <a-col :span="12">
                        <a-statistic title="订单数" :value="3294" />
                    </a-col>
                </a-row>

                <a-divider />

                <!-- 包含 ant-design 表格 -->
                <a-table
                        :columns="columns"
                        :data-source="data"
                        :pagination="false"
                />
            </div>

            <!-- 操作按钮 -->
            <template #actions>
                <a-button type="primary" @click="captureCard">
                    <camera-outlined /> 下载图片
                </a-button>
                <a-button @click="captureAsImage">仅截图</a-button>
            </template>
        </a-card>

        <!-- 预览区域 -->
        <a-modal v-model:visible="previewVisible" title="截图预览" width="800px">
            <img :src="previewImage" style="width: 100%" v-if="previewImage" />
            <p><small>长按保存图片</small></p>
        </a-modal>
    </div>
</template>

<script setup>
    import { ref } from 'vue'
    import { message } from 'ant-design-vue'
    import domtoimagemore from 'dom-to-image-more'
    import { CameraOutlined } from '@ant-design/icons-vue'

    // 数据
    const chartContainer = ref(null)
    const previewVisible = ref(false)
    const previewImage = ref('')

    // ant-design 表格数据
    const columns = [
        { title: '产品', dataIndex: 'product', key: 'product' },
        { title: '销量', dataIndex: 'sales', key: 'sales' },
        { title: '增长率', dataIndex: 'growth', key: 'growth' },
    ]

    const data = [
        { key: '1', product: '产品A', sales: 1234, growth: '12%' },
        { key: '2', product: '产品B', sales: 2345, growth: '8%' },
        { key: '3', product: '产品C', sales: 3456, growth: '15%' },
    ]

    // 截图方法
    const captureCard = async () => {
        try {
            message.loading({ content: '正在生成截图...', key: 'capture' })

            const node = document.getElementById('capture-card')

            // 使用 dom-to-image-more
            const dataUrl = await domtoimagemore.toPng(node, {
                quality: 0.95,
                width: node.clientWidth * 2,
                height: node.clientHeight * 2,
                style: {
                    transform: 'scale(1)',
                    transformOrigin: 'top left'
                },
                filter: (node) => {
                    // 过滤掉不需要的元素，比如按钮
                    return !(node.classList && node.classList.contains('ant-card-actions'))
                }
            })

            // 下载图片
            downloadImage(dataUrl, '报表截图.png')

            message.success({ content: '截图已保存', key: 'capture' })
        } catch (error) {
            message.error({ content: `截图失败: ${error.message}`, key: 'capture' })
            console.error('截图错误:', error)
        }
    };

    // 另一种方式：截图并预览
    const captureAsImage = async () => {
        if (!chartContainer.value) return

        try {
            const dataUrl = await domtoimagemore.toPng(chartContainer.value, {
                bgcolor: '#ffffff',
                quality: 1,
                cacheBust: true // 防止缓存问题
            });

            previewImage.value = dataUrl;
            previewVisible.value = true
        } catch (error) {
            message.error('生成预览失败')
        }
    };

    // 下载图片函数
    const downloadImage = (dataUrl, filename) => {
        const link = document.createElement('a')
        link.download = filename
        link.href = dataUrl
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
</script>